import { SyncOutlined } from '@ant-design/icons'
import {
  Button,
  Card,
  Icon,
  Input,
  Popover,
  Switch,
  TimePicker,
  Radio,
  Tabs,
  Modal,
  message,
  Tooltip,
} from 'antd'
import { API } from 'src/utils/interceptor'
import { Auth } from 'aws-amplify'
import moment from 'moment'
import React, { Fragment, useEffect, useState, useRef } from 'react'
import { ReactMultiEmail, isEmail } from 'react-multi-email'
import { useDispatch, useSelector } from 'react-redux'
import { uploadFile } from 'src/utils/uploadFile'
import { BodyText, H4, H3 } from 'src/branding/typography'
import {
  FoodSafetyHeroBand,
  FoodSafetyPageTitle,
} from 'src/components/food-safety/FoodSafetyPageChrome'
import {
  FOOD_SAFETY_SECONDARY_TEXT,
  FOOD_SAFETY_SURFACE,
} from 'src/constants/foodSafety'
import { RECIPE_ALERT_RECIPIENTS_NOTE } from 'src/utils/recipeMonitoring'
import HeaderScreen from 'src/components/shared/header-screen/HeaderScreen'
import FadeIn from 'src/components/styled/FadeIn'
import CreateNewUserModal from 'src/components/CreateNewUserModal'
import ChangePrimaryOwnerModal from 'src/components/ChangePrimaryOwnerModal'
import FreePlanRoleModal from 'src/components/FreePlanRoleModal'
import RolePermissionsModal from 'src/components/RolePermissionsModal'
import ManageCustomRolesSection from 'src/screens/settings/ManageCustomRolesSection'
import {
  editVenue,
  updateVenueCode,
  getVenue,
  setVenue,
} from 'src/features/VenueSlice'
import { setAccount } from 'src/features/AuthSlice'
import { editVenueSuppliers } from 'src/features/VenueSuppliersSlice'
import { SuccessNotification } from 'src/notifications/SuccessNotification'
import styled from 'styled-components/macro'
import _ from 'underscore'
import VenueRoleSelect from 'src/components/VenueRoleSelect'
import { VENUE_ADMIN, getRoleColor } from 'src/utils/roles'
import { isBlocked } from 'src/utils/permissions'
import {
  canManageVenueUsers,
  CUSTOM_ROLES_HEADING_CUE,
  CUSTOM_ROLES_INVITE_HINT_ACTION,
  CUSTOM_ROLES_INVITE_HINT_LEAD,
  CUSTOM_ROLES_NEW_BADGE,
  getDisplayedVenueRole,
  getMissingCustomRoleAssignmentCopy,
  getVenueRoleCardChipSummary,
  getVenueRoleDisplayName,
  getVenueRoleSelectValue,
  isCustomRoleId,
  isCustomRolesPaidPlan,
  CANNOT_REMOVE_SELF_COPY,
} from 'src/utils/venueRoleCapabilities'
import PermissionBlockScreen from 'src/components/shared/PermissionBlockScreen'
import { canChangePrimaryOwner } from 'src/utils/adminAccess'
import { resolveSettingsCurrentUserRole } from 'src/utils/settingsUserRole'
import { useHistory, useLocation } from 'react-router-dom'
import Subscriptions from 'src/screens/subscriptions/Subscriptions'
import Integrations from 'src/screens/integrations/Integrations'
import SuccessHubSettings from 'src/components/growthEngine/SuccessHubSettings'
import OlliePushSettings from 'src/components/ollie/OlliePushSettings'
import {
  CANNOT_INVITE_SELF_COPY,
  getAddUserToVenueErrorMessage,
  getAlreadyOnVenueMessage,
  getExistingUserInviteAccessCopy,
  getInviteNameValidationError,
  isAlreadyOnVenueApiError,
  isEmailAlreadyOnVenue,
  isInvitingOwnAccount,
  resolveInvitedUserName,
  scrubAutofilledInviterEmail,
} from 'src/utils/venueInviteHelpers'
import {
  getOwnDisplayNameError,
  normalizeAccountDisplayName,
} from 'src/utils/accountDisplayName'

const SETTINGS_TAB_KEYS = [
  'users',
  'general',
  'notifications',
  'subscriptions',
  'integrations',
  'manage',
]

const settingsTabFromSearch = search => {
  const tab = new URLSearchParams(search || '').get('tab')
  return SETTINGS_TAB_KEYS.includes(tab) ? tab : 'users'
}

const Settings = () => {
  const dispatch = useDispatch()
  const history = useHistory()
  const location = useLocation()
  const account = useSelector(state => state.auth.account)
  const venue = useSelector(state => state.venue.venue)
  const { isAdmin } = account
  const isTFRAdmin = account && account.TFRAdmin
  const isJustAdmin = account && account.JUSTAdmin
  const isGreenAdmin = account && account.GREENAdmin
  const content = (
    <div>
      <p style={{ maxWidth: 320 }}>
        Go to your website and right click (on Windows) or control + click (on
        Mac) over your logo and select &apos;Open image in a new tab&apos;. Then
        copy the web address (URL) of the new tab and paste it below.
      </p>
      <p style={{ maxWidth: 320 }}>Let us know if you need more help!</p>
    </div>
  )
  const {
    _id: venueId = '',
    addressLine1 = '',
    addressLine2 = '',
    addressCity = '',
    addressPostCode = '',
    TFRVenue: TFRVenueFromRedux = '',
    GREENVenue: GREENVenueFromRedux = '',
    JUSTVenue: JUSTVenueFromRedux = '',
    isPriceChangesVisible: isPriceChangesVisibleFromRedux = '',
    isPricesHidden: isPricesHiddenFromRedux = '',
    isInvoices: isInvoicesFromRedux = '',
    dataplusIntegration: isDataplusIntegrationFromRedux = '',
    isAddSupplierButtonHidden: isAddSupplierButtonHiddenFromRedux = '',
    isAccountNumberEditable: isAccountNumberEditableFromRedux = '',
    orderReminder: orderReminderFromRedux = '',
    phoneNumber: phoneNumberFromRedux = '',
    venueLogo: venueLogoFromRedux = '',
    notificationTime: notificationTimeFromRedux = +new Date(),
    title: titleFromRedux = '',
    code: venueCodeFromRedux = '',
    statsReciveEmails: statsReciveEmailsFromRedux = [],
    gpReportEmails: gpReportEmailsFromRedux = [],
    additionalChatSupport: additionalChatSupportFromRedux = {
      title: '',
      emailAddress: '',
    },
    activityEmailFrequency: activityEmailFrequencyFromRedux,
    sageVenueCode: sageVenueCodeFromRedux = '',

    // venueDeliveryDays: venueDeliveryDaysFromVenue = {},
  } = venue || {}

  const hasAllSettings =
    addressLine1 && addressLine2 && addressCity && addressPostCode

  const addressFromServer = {
    addressLine1,
    addressLine2,
    addressCity,
    addressPostCode,
  }

  const [address, setAddress] = useState({ ...addressFromServer })
  const [phoneNumber, setPhoneNumber] = useState(phoneNumberFromRedux)
  const [title, setTitle] = useState(titleFromRedux)
  const [venueLogo, setVenueLogo] = useState(venueLogoFromRedux)
  const [code, setCode] = useState(venueCodeFromRedux)
  const [sageVenueCode, setSageVenueCode] = useState(sageVenueCodeFromRedux)
  const [TFRVenue, setTFRVenue] = useState(TFRVenueFromRedux)
  const [GREENVenue, setGREENVenue] = useState(GREENVenueFromRedux)
  const [JUSTVenue, setJUSTVenue] = useState(JUSTVenueFromRedux)
  const [isInvoices] = useState(isInvoicesFromRedux)
  const [statsReciveEmails, setStatsRecieveEmails] = useState(
    statsReciveEmailsFromRedux?.length
      ? statsReciveEmailsFromRedux
      : gpReportEmailsFromRedux || [],
  )
  const [dataplusIntegration, setDataplusIntegration] = useState(
    isDataplusIntegrationFromRedux,
  )
  const [isPriceChangesVisible, setIsPriceChangesVisible] = useState(
    isPriceChangesVisibleFromRedux,
  )

  const [isPricesHidden, setIsPricesHidden] = useState(isPricesHiddenFromRedux)
  const [isAccountNumberEditable, setIsAccountNumberEditable] = useState(
    isAccountNumberEditableFromRedux,
  )
  const [isAddSupplierButtonHidden, setIsAddSupplierButtonHidden] = useState(
    isAddSupplierButtonHiddenFromRedux,
  )
  const [orderReminder, setorderReminder] = useState(orderReminderFromRedux)
  const [activityEmailFrequency, setActivityEmailFrequency] = useState(
    activityEmailFrequencyFromRedux || 'daily',
  )
  const [notificationTime, setNotificationTime] = useState(
    notificationTimeFromRedux,
  )
  const [additionalChatSupport, setAdditionalChatSupport] = useState({
    ...additionalChatSupportFromRedux,
  })
  const [activeTab, setActiveTab] = useState(() =>
    settingsTabFromSearch(location.search),
  )
  const [showSaved, setShowSaved] = useState(false)
  const [isUploadingLogo, setIsUploadingLogo] = useState(false)
  const [logoUploadSuccess, setLogoUploadSuccess] = useState(false)
  const fileInputRef = useRef(null)
  // User management state
  const [newUserEmail, setNewUserEmail] = useState('')
  const [isAddingUser, setIsAddingUser] = useState(false)
  const [isRemovingUser, setIsRemovingUser] = useState(false)
  const [userToRemove, setUserToRemove] = useState(null)
  const [showAddUserConfirm, setShowAddUserConfirm] = useState(false)
  const [pendingUserEmail, setPendingUserEmail] = useState('')
  const [pendingUserName, setPendingUserName] = useState('')
  const [pendingUserNameError, setPendingUserNameError] = useState('')
  // Create new user modal state
  const [showCreateNewUserModal, setShowCreateNewUserModal] = useState(false)
  const [isCreatingUser, setIsCreatingUser] = useState(false)
  const [createUserError, setCreateUserError] = useState('')
  // Role management state
  const [selectedRole, setSelectedRole] = useState(VENUE_ADMIN)
  const [showFreePlanModal, setShowFreePlanModal] = useState(false)
  const [showRolePermissionsModal, setShowRolePermissionsModal] =
    useState(false)
  const [startCreateCustomRoleToken, setStartCreateCustomRoleToken] =
    useState(0)
  const canManagePrimaryOwner = canChangePrimaryOwner(account, venue)
  const [showChangePrimaryOwnerModal, setShowChangePrimaryOwnerModal] =
    useState(false)
  const [editingOwnName, setEditingOwnName] = useState(false)
  const [ownNameDraft, setOwnNameDraft] = useState('')
  const [ownNameError, setOwnNameError] = useState('')
  const [savingOwnName, setSavingOwnName] = useState(false)
  // const [venueDeliveryDays, setVenueDeliveryDays] = useState(
  //   venueDeliveryDaysFromVenue,
  // )

  useEffect(() => {
    setCode(venueCodeFromRedux)
  }, [venueCodeFromRedux])

  useEffect(() => {
    setSageVenueCode(sageVenueCodeFromRedux)
  }, [sageVenueCodeFromRedux])

  const updateAddress = (param, value) => {
    setAddress({
      ...address,
      [param]: value,
    })
  }

  const setExclusiveVenueType = (type, checked) => {
    if (checked) {
      setTFRVenue(type === 'TFR')
      setGREENVenue(type === 'GREEN')
      setJUSTVenue(type === 'JUST')
    } else if (type === 'TFR') {
      setTFRVenue(false)
    } else if (type === 'GREEN') {
      setGREENVenue(false)
    } else {
      setJUSTVenue(false)
    }
  }

  // const updateDeliveryDays = param => {
  //   const venueDeliveryDaysCopy = { ...venueDeliveryDays }
  //   venueDeliveryDaysCopy[param] = !venueDeliveryDaysCopy[param]
  //   setVenueDeliveryDays(venueDeliveryDaysCopy)
  // }

  const handleLogoFileSelect = async event => {
    const file = event.target.files[0]
    if (!file) return

    // Validate file type
    const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png']
    if (!allowedTypes.includes(file.type)) {
      alert('Please select a JPG or PNG image file.')
      return
    }

    // Validate file size (5MB max)
    const maxSize = 5 * 1024 * 1024 // 5MB in bytes
    if (file.size > maxSize) {
      alert('File size must be under 5MB. Please choose a smaller image.')
      return
    }

    setIsUploadingLogo(true)
    setLogoUploadSuccess(false)

    try {
      const uploadResult = await uploadFile(file)
      if (uploadResult && uploadResult.signedURL) {
        setVenueLogo(uploadResult.signedURL)
        setLogoUploadSuccess(true)
        setTimeout(() => setLogoUploadSuccess(false), 3000)

        // Auto-save the venue with new logo
        submit()
      } else {
        throw new Error('Upload failed')
      }
    } catch (error) {
      console.error('Logo upload error:', error)
      alert(
        error.message || 'Upload failed. Please try a different image or URL.',
      )
    } finally {
      setIsUploadingLogo(false)
      // Clear the file input
      if (fileInputRef.current) {
        fileInputRef.current.value = ''
      }
    }
  }

  const handleRemoveLogo = () => {
    setVenueLogo('')
    setLogoUploadSuccess(false)
  }

  // User management functions
  const handleAddUser = async () => {
    if (!newUserEmail || !isEmail(newUserEmail)) {
      message.error('Please enter a valid email address')
      return
    }

    if (isInvitingOwnAccount(newUserEmail, account)) {
      message.warning(CANNOT_INVITE_SELF_COPY)
      setNewUserEmail('')
      return
    }

    if (isEmailAlreadyOnVenue(newUserEmail, venue)) {
      message.info(getAlreadyOnVenueMessage(newUserEmail))
      setNewUserEmail('')
      return
    }

    setIsAddingUser(true)
    try {
      // First, check if the email exists in the system
      const checkResponse = await API.post('api2', 'admin/checkEmailExists', {
        body: {
          email: newUserEmail,
        },
      })

      if (checkResponse.success) {
        // Email exists - show confirmation modal for adding existing user
        setPendingUserEmail(newUserEmail)
        setPendingUserName(
          resolveInvitedUserName(checkResponse?.data?.name, newUserEmail) ===
            String(newUserEmail || '')
              .trim()
              .toLowerCase()
            ? ''
            : checkResponse?.data?.name || '',
        )
        setPendingUserNameError('')
        setShowAddUserConfirm(true)
      } else {
        // Email doesn't exist - show create new user modal with pre-filled email
        setPendingUserEmail(newUserEmail) // Store the email for pre-filling
        setShowCreateNewUserModal(true)
      }
    } catch (error) {
      console.error('Error checking email:', error)
      // If it's a 404 error, it means the email doesn't exist
      if (error.response?.status === 404) {
        // Email doesn't exist - show create new user modal with pre-filled email
        setPendingUserEmail(newUserEmail) // Store the email for pre-filling
        setShowCreateNewUserModal(true)
      } else {
        const errorMessage =
          error.response?.data?.message ||
          'Failed to check email. Please try again.'
        message.error(errorMessage)
      }
    } finally {
      setIsAddingUser(false)
    }
  }

  const handleAddUserConfirm = async () => {
    const nameError = getInviteNameValidationError(
      pendingUserName,
      pendingUserEmail,
    )
    if (nameError) {
      setPendingUserNameError(nameError)
      return
    }

    setIsAddingUser(true)
    try {
      const response = await API.post('api2', 'admin/addUserToVenue', {
        body: {
          email: pendingUserEmail,
          venueId: venueId,
          role: selectedRole, // Pass selected role
          // Send the typed name (may be blank). Server resolves blank /
          // mistaken inviter-email to the invitee's email — never the inviter's.
          name: pendingUserName,
        },
      })

      if (response.success) {
        message.success('User added successfully!')
        setNewUserEmail('')
        setPendingUserEmail('')
        setPendingUserName('')
        setPendingUserNameError('')
        setSelectedRole(VENUE_ADMIN) // Reset to default role
        setShowAddUserConfirm(false)
        // Ensure we stay on the Users tab
        setActiveTab('users')
        // Refresh venue data to get updated user list
        dispatch(getVenue(venueId))
        return
      }

      if (isAlreadyOnVenueApiError(response)) {
        message.info(getAlreadyOnVenueMessage(pendingUserEmail))
      } else {
        message.error(
          response?.message || 'Failed to add user. Please try again.',
        )
      }
      setShowAddUserConfirm(false)
      setPendingUserEmail('')
      setPendingUserName('')
      setPendingUserNameError('')
      setNewUserEmail('')
    } catch (error) {
      console.error('Error adding user:', error)
      if (isAlreadyOnVenueApiError(error)) {
        message.info(getAlreadyOnVenueMessage(pendingUserEmail))
      } else {
        message.error(getAddUserToVenueErrorMessage(error))
      }
      setShowAddUserConfirm(false)
      setPendingUserEmail('')
      setPendingUserName('')
      setPendingUserNameError('')
      setNewUserEmail('')
    } finally {
      setIsAddingUser(false)
    }
  }

  const handleAddUserCancel = () => {
    setShowAddUserConfirm(false)
    setPendingUserEmail('')
    setPendingUserName('')
    setPendingUserNameError('')
    setIsAddingUser(false)
  }

  const handleRemoveUserClick = user => {
    const currentAccountId = account?._id
    if (
      currentAccountId &&
      user?._id &&
      String(user._id) === String(currentAccountId)
    ) {
      message.warning(CANNOT_REMOVE_SELF_COPY)
      return
    }
    setUserToRemove(user)
  }

  const handleRemoveUserConfirm = async () => {
    if (!userToRemove) return

    setIsRemovingUser(true)
    try {
      const response = await API.post('api2', 'admin/removeUserFromVenue', {
        body: {
          accountId: userToRemove._id,
          venueId: venueId,
        },
      })

      if (response.success) {
        message.success('User removed successfully!')
        setUserToRemove(null)
        // Ensure we stay on the Users tab
        setActiveTab('users')
        // Refresh venue data to get updated user list
        dispatch(getVenue(venueId))
      }
    } catch (error) {
      console.error('Error removing user:', error)
      const errorMessage =
        error.response?.data?.message ||
        'Failed to remove user. Please try again.'
      message.error(errorMessage)
    } finally {
      setIsRemovingUser(false)
    }
  }

  const handleRemoveUserCancel = () => {
    setUserToRemove(null)
  }

  // Role management helpers
  const currentPlan = venue?.usageLimits?.currentPlan
  const isFreePlan = !isCustomRolesPaidPlan(currentPlan)

  const currentUserRole = resolveSettingsCurrentUserRole({
    account,
    venue,
    venueId,
  })
  const canManageUsers = canManageVenueUsers(currentUserRole)
  const showSubscriptionsTab = !isBlocked(
    'subscriptions',
    currentUserRole,
    venue?.customRoles,
  )
  const showIntegrationsTab = !isBlocked(
    'integrations',
    currentUserRole,
    venue?.customRoles,
  )

  useEffect(() => {
    const next = settingsTabFromSearch(location.search)
    const allowed =
      (next === 'subscriptions' && !showSubscriptionsTab) ||
      (next === 'integrations' && !showIntegrationsTab) ||
      (next === 'manage' && !isAdmin)
        ? 'users'
        : next
    setActiveTab(allowed)
    if (allowed !== next && venueId) {
      history.replace(`/v/${venueId}/settings`)
    }
  }, [
    location.search,
    showSubscriptionsTab,
    showIntegrationsTab,
    isAdmin,
    venueId,
    history,
  ])

  const handleTabChange = key => {
    setActiveTab(key)
    if (!venueId) return
    const search = key === 'users' ? '' : `?tab=${key}`
    history.replace(`/v/${venueId}/settings${search}`)
  }

  // Get user's role for this venue (defaults to VENUE_ADMIN)
  const getUserRole = user => {
    if (!user) return VENUE_ADMIN
    // Check if this is the primary owner
    const venueAccountId =
      venue?.account?._id || venue?.account?.toString() || venue?.account
    const userId = user._id || user._id?.toString()
    if (
      venueAccountId &&
      userId &&
      venueAccountId.toString() === userId.toString()
    ) {
      return VENUE_ADMIN
    }
    // Use venueRoles for this venue first so a defaulted Admin role cannot
    // hide a custom role the assigned-count query still sees.
    return getDisplayedVenueRole(user, venueId)
  }

  // State for tracking role updates (per user)
  const [updatingRoleUserId, setUpdatingRoleUserId] = useState(null)

  const openOwnNameEditor = currentName => {
    setOwnNameDraft(currentName || '')
    setOwnNameError('')
    setEditingOwnName(true)
  }

  const handleSaveOwnName = async () => {
    const name = normalizeAccountDisplayName(ownNameDraft)
    const nameError = getOwnDisplayNameError(name)
    if (nameError) {
      setOwnNameError(nameError)
      return
    }
    setSavingOwnName(true)
    try {
      const response = await API.patch('api2', 'account/name', {
        body: { name },
      })
      const savedName = response?.data?.name || name
      dispatch(setAccount({ ...account, name: savedName }))
      if (venue) {
        const nextVenue = { ...venue }
        if (
          venue.account &&
          String(venue.account._id) === String(account._id)
        ) {
          nextVenue.account = { ...venue.account, name: savedName }
        }
        if (Array.isArray(venue.additionalUsers)) {
          nextVenue.additionalUsers = venue.additionalUsers.map(user =>
            String(user._id) === String(account._id)
              ? { ...user, name: savedName }
              : user,
          )
        }
        dispatch(setVenue(nextVenue))
      }
      setEditingOwnName(false)
      message.success('Your name has been updated')
    } catch (error) {
      setOwnNameError(
        error?.response?.data?.message ||
          'Could not update your name. Try again.',
      )
    } finally {
      setSavingOwnName(false)
    }
  }

  // Handle role change - call API to update role
  const handleRoleChange = async (userId, newRole) => {
    const currentAccountId = account?._id
    if (
      currentAccountId &&
      userId &&
      String(userId) === String(currentAccountId)
    ) {
      return
    }
    if (isFreePlan && isCustomRoleId(newRole)) {
      setShowFreePlanModal(true)
      return
    }

    setUpdatingRoleUserId(userId)

    // Store previous role for potential revert
    const user = venue?.additionalUsers?.find(
      u => (u._id || u._id?.toString()) === userId?.toString(),
    )
    const previousRole = getUserRole(user)

    // Optimistically update the user's role in local state for immediate UI feedback
    if (venue && venue.additionalUsers) {
      const updatedUsers = venue.additionalUsers.map(u => {
        if ((u._id || u._id?.toString()) === userId?.toString()) {
          return {
            ...u,
            role: newRole,
            venueRoles: {
              ...(u.venueRoles || {}),
              [venueId]: newRole,
            },
          }
        }
        return u
      })
      dispatch(setVenue({ ...venue, additionalUsers: updatedUsers }))
    }

    try {
      const response = await API.post('api2', 'admin/updateUserRole', {
        body: {
          userId: userId,
          venueId: venueId,
          role: newRole,
        },
      })

      if (response.success) {
        message.success('User role updated successfully!')
        // Refresh venue data from backend to ensure consistency
        dispatch(getVenue(venueId))
      } else {
        throw new Error(response.message || 'Failed to update role')
      }
    } catch (error) {
      console.error('Error updating role:', error)
      const errorMessage =
        error.response?.data?.message ||
        'Failed to update user role. Please try again.'
      message.error(errorMessage)

      // Revert optimistic update on error
      if (venue && venue.additionalUsers) {
        const revertedUsers = venue.additionalUsers.map(u => {
          if ((u._id || u._id?.toString()) === userId?.toString()) {
            return {
              ...u,
              role: previousRole,
              venueRoles: {
                ...(u.venueRoles || {}),
                [venueId]: previousRole,
              },
            }
          }
          return u
        })
        dispatch(setVenue({ ...venue, additionalUsers: revertedUsers }))
      }

      // Refresh venue data to ensure UI matches backend state
      dispatch(getVenue(venueId))
    } finally {
      setUpdatingRoleUserId(null)
    }
  }

  // Create new user handlers
  const handleCreateNewUser = async userData => {
    setIsCreatingUser(true)
    setCreateUserError('')

    try {
      const resolvedName = resolveInvitedUserName(userData.name, userData.email)

      // Step 1: Create the user account in Cognito
      console.log('Creating user account:', userData.email)
      await Auth.signUp({
        username: userData.email,
        password: userData.password,
        attributes: {
          name: resolvedName,
        },
      })

      console.log('User account created successfully')

      // Step 2: Send welcome email and create account (this also assigns to venue)
      console.log('Sending welcome email to:', userData.email)
      const emailResponse = await API.post('api2', 'admin/sendWelcomeEmail', {
        body: {
          userName: resolvedName,
          userEmail: userData.email,
          userPassword: userData.password,
          venueName: venue?.title || 'your venue',
          venueId: venueId,
          role: userData.role || selectedRole, // Pass role from modal
        },
      })

      if (emailResponse.success) {
        console.log(
          'Welcome email sent successfully and user assigned to venue',
        )

        // Step 3: Ensure we stay on the Users tab and refresh venue data to show the new user
        setActiveTab('users')
        dispatch(getVenue(venueId))

        // Step 4: Show success message
        message.success(
          `User ${resolvedName} (${userData.email}) created successfully! Welcome email sent.`,
        )

        // Step 5: Clean up and close modal
        setShowCreateNewUserModal(false)
        setNewUserEmail('') // Clear the email input
        setPendingUserEmail('') // Clear the pending email
        setSelectedRole(VENUE_ADMIN) // Reset to default role
      } else {
        throw new Error(emailResponse.message || 'Failed to send welcome email')
      }
    } catch (error) {
      console.error('Error in user creation flow:', error)

      // Handle different types of errors
      let errorMessage = 'Failed to create user. Please try again.'

      if (error.code === 'UsernameExistsException') {
        errorMessage = 'A user with this email already exists.'
      } else if (error.code === 'InvalidPasswordException') {
        errorMessage =
          'Password does not meet requirements. Please try a stronger password.'
      } else if (error.code === 'InvalidParameterException') {
        errorMessage = 'Invalid user information provided.'
      } else if (error.message) {
        errorMessage = error.message
      }

      setCreateUserError(errorMessage)
    } finally {
      setIsCreatingUser(false)
    }
  }

  const handleCreateNewUserCancel = () => {
    setShowCreateNewUserModal(false)
    setCreateUserError('')
    setPendingUserEmail('') // Clear the pending email
    setSelectedRole(VENUE_ADMIN) // Reset to default role
  }

  const submit = () => {
    // eslint-disable-next-line no-unused-vars
    const { addressLine2, ...rest } = address
    const isEmptyAddress = Object.values(rest).some(
      item => item === null || item === '',
    )

    if (isEmptyAddress) {
      alert('Please complete your address')
      return
    }

    const isEmptyPhone = !phoneNumber
    if (isEmptyPhone) {
      alert('Please complete your phone number')
      return
    }

    const isEmptyTitle = !title
    if (isEmptyTitle) {
      alert('Please complete your venue title')
      return
    }

    const isEmptyCode = code.toString().length < 6
    if (isEmptyCode) {
      alert('The venue code has to have at least 6 characters')
      return
    }
    // if (!_.isEqual(venueDeliveryDays, venueDeliveryDaysFromVenue)) {
    //   dispatch(
    //     editVenueSuppliers({
    //       venue: venueId,
    //       hasVenueUpdateDeliveryDays: true,
    //     }),
    //   )
    // }

    if (hasAllSettings && !_.isEqual(address, addressFromServer)) {
      dispatch(
        editVenueSuppliers({
          venue: venueId,
          hasVenueUpdateAddress: true,
        }),
      )
    }

    dispatch(
      editVenue(
        {
          phoneNumber,
          title,
          notificationTime,
          code,
          venueLogo,
          additionalChatSupport,
          TFRVenue,
          GREENVenue,
          JUSTVenue,
          isPriceChangesVisible,
          orderReminder,
          isPricesHidden,
          isInvoices,
          dataplusIntegration,
          isAddSupplierButtonHidden,
          isAccountNumberEditable,
          statsReciveEmails,
          gpReportEmails: statsReciveEmails,
          activityEmailFrequency,
          sageVenueCode,
          // venueDeliveryDays,
          ...address,
        },
        venueId,
      ),
    )

    // Show saved indicator
    setShowSaved(true)
    setTimeout(() => setShowSaved(false), 2000)
  }

  const refreshVenueCode = () => dispatch(updateVenueCode(venueId))

  // const refreshAdminVenueCode = () => dispatch(updateAdminVenueCode(venueId))

  const getEmail = async () => {
    try {
      console.log('venueId---> ', venueId)
      await API.get('api', `getWeeklyInvoice/${venueId}`)
      SuccessNotification({
        message: 'Venue Statistics',
        description:
          'Statistics have been successfully sent to the provided emails.',
      })
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <Wrapper>
      <HeaderScreen
        title={'Settings'}
        subTitle={'Manage your venue preferences, emails, and users'}
      ></HeaderScreen>
      {venue && (
        <Fragment>
          <StyledTabs
            activeKey={activeTab}
            onChange={handleTabChange}
            type='card'
          >
            {/* USERS TAB */}
            <Tabs.TabPane tab={<span>👥 Users</span>} key='users'>
              <SettingsTab>
                {isBlocked(
                  'settings-users',
                  currentUserRole,
                  venue?.customRoles,
                ) ? (
                  <SettingsPane>
                    <PermissionBlockScreen />
                  </SettingsPane>
                ) : (
                  <SettingsStack>
                    <FoodSafetyHeroBand>
                      <SettingsEyebrow>Users</SettingsEyebrow>
                      <FoodSafetyPageTitle>Venue users</FoodSafetyPageTitle>
                      <SettingsLead>
                        Manage who has access to this venue.
                      </SettingsLead>
                      <SettingsNote data-testid='recipe-alert-recipients'>
                        {RECIPE_ALERT_RECIPIENTS_NOTE}
                      </SettingsNote>
                    </FoodSafetyHeroBand>
                    <SettingsPane>
                      <Element>
                        {/* Primary Owner Section */}
                        {venue?.account && (
                          <PrimaryOwnerSection>
                            <H4>Primary Owner</H4>
                            <UserCard>
                              <UserInfo>
                                <UserName>
                                  <span>
                                    {venue.account.name || 'Unknown Name'}
                                  </span>
                                  {Boolean(account?._id) &&
                                  String(venue.account._id) ===
                                    String(account._id) ? (
                                    <Tooltip title='Edit your name'>
                                      <EditNameButton
                                        type='button'
                                        data-testid='settings-edit-own-name'
                                        aria-label='Edit your name'
                                        onClick={() =>
                                          openOwnNameEditor(venue.account.name)
                                        }
                                      >
                                        <Icon type='edit' />
                                      </EditNameButton>
                                    </Tooltip>
                                  ) : null}
                                </UserName>
                                <UserEmail>
                                  {venue.account.emailAddress}
                                </UserEmail>
                                <UserRole
                                  roleColor={getRoleColor('PRIMARY_OWNER')}
                                >
                                  Primary Owner
                                </UserRole>
                                <UserAdded>
                                  Added on venue creation. The current primary
                                  owner is treated as the business owner for
                                  this venue.
                                </UserAdded>
                              </UserInfo>
                              <UserActions>
                                {canManagePrimaryOwner ? (
                                  <div
                                    style={{
                                      display: 'flex',
                                      flexDirection: 'column',
                                      gap: 8,
                                    }}
                                  >
                                    <Button
                                      type='primary'
                                      icon='swap'
                                      onClick={() =>
                                        setShowChangePrimaryOwnerModal(true)
                                      }
                                    >
                                      Change primary owner
                                    </Button>
                                    <ContactSupport>
                                      <Icon type='info-circle' />
                                      <span>
                                        Choose from existing additional users to
                                        promote them to owner.
                                      </span>
                                    </ContactSupport>
                                  </div>
                                ) : (
                                  <ContactSupport>
                                    <Icon type='info-circle' />
                                    <span>
                                      The primary owner is managed by OMS or
                                      your brand admin. Speak to your head
                                      office or OMS if this needs to change.
                                    </span>
                                  </ContactSupport>
                                )}
                              </UserActions>
                            </UserCard>
                          </PrimaryOwnerSection>
                        )}

                        {/* Additional Users Section */}
                        <AdditionalUsersSection>
                          <DivFlex
                            style={{
                              justifyContent: 'space-between',
                              alignItems: 'center',
                              marginBottom: '16px',
                            }}
                          >
                            <DivFlex
                              style={{ alignItems: 'center', gap: '8px' }}
                            >
                              <H4>Additional Users</H4>
                              <CustomRoleCue
                                type='button'
                                onClick={() =>
                                  canManageUsers &&
                                  setStartCreateCustomRoleToken(
                                    token => token + 1,
                                  )
                                }
                                disabled={!canManageUsers}
                              >
                                <NewBadge>{CUSTOM_ROLES_NEW_BADGE}</NewBadge>
                                {CUSTOM_ROLES_HEADING_CUE}
                              </CustomRoleCue>
                            </DivFlex>
                            <Tooltip title='Learn what each role can access'>
                              <Button
                                type='primary'
                                icon='info-circle'
                                onClick={() =>
                                  setShowRolePermissionsModal(true)
                                }
                                style={{ padding: '0 10px', height: 32 }}
                              >
                                Learn about roles
                              </Button>
                            </Tooltip>
                          </DivFlex>

                          <ManageCustomRolesSection
                            venueId={venueId}
                            customRoles={venue?.customRoles}
                            additionalUsers={venue?.additionalUsers}
                            canManage={canManageUsers}
                            isFreePlan={isFreePlan}
                            startCreateToken={startCreateCustomRoleToken}
                            onFreePlanPaywall={() => setShowFreePlanModal(true)}
                            onCustomRolesChange={nextRoles => {
                              dispatch(
                                setVenue({
                                  ...venue,
                                  customRoles: nextRoles,
                                }),
                              )
                            }}
                          />

                          {/* Upgrade Banner for Free Plan */}
                          {isFreePlan && (
                            <UpgradeBanner>
                              <UpgradeBannerText>
                                <strong>Want a role of your own?</strong> Admin,
                                Head Chef / GM, Chef, Order Only, and Kitchen
                                Porter are on OMS Lite. A custom role, with its
                                own ticks, is on Starter, Growth or Pro.
                              </UpgradeBannerText>
                              <Button
                                type='primary'
                                onClick={() => {
                                  window.location.href = `/v/${venueId}/subscriptions/oms-plans`
                                }}
                              >
                                Upgrade Plan
                              </Button>
                            </UpgradeBanner>
                          )}

                          {/* View-only when the current user cannot manage users */}
                          {!canManageUsers && (
                            <ViewOnlyMessage>
                              Only Admins can manage users. You can look, but no
                              editing.
                            </ViewOnlyMessage>
                          )}

                          <InviteUserSection>
                            <InviteUserHeader>
                              <InviteUserTitle>Invite a user</InviteUserTitle>
                              <InviteUserSubtitle>
                                Add someone to this venue by email and choose
                                their role. They only get access to this venue.
                              </InviteUserSubtitle>
                            </InviteUserHeader>
                            <AddUserForm>
                              <InviteEmailField className='invite-user-email'>
                                <InviteFieldLabel htmlFor='invite-user-email'>
                                  Email address
                                </InviteFieldLabel>
                                <Input
                                  id='invite-user-email'
                                  type='email'
                                  placeholder='Email address'
                                  autoComplete='off'
                                  value={newUserEmail}
                                  onChange={e =>
                                    setNewUserEmail(e.target.value)
                                  }
                                  onPressEnter={handleAddUser}
                                />
                              </InviteEmailField>
                              <RoleSelectWrapper className='invite-role-select'>
                                <VenueRoleSelect
                                  value={selectedRole}
                                  customRoles={venue?.customRoles}
                                  lockCustomRoles={isFreePlan}
                                  onLockedCustomRole={() =>
                                    setShowFreePlanModal(true)
                                  }
                                  tooltipTitle={
                                    isFreePlan
                                      ? 'Admin, Head Chef / GM, Chef, Order Only, and Kitchen Porter are on OMS Lite. Custom roles are on Starter.'
                                      : 'Select the access level for this user. You can adjust it later.'
                                  }
                                  onChange={setSelectedRole}
                                  disabled={!canManageUsers}
                                  style={{ width: '100%' }}
                                />
                              </RoleSelectWrapper>
                              <Button
                                type='primary'
                                className='invite-user-submit'
                                onClick={handleAddUser}
                                loading={isAddingUser}
                                disabled={!newUserEmail || !canManageUsers}
                              >
                                Invite User
                              </Button>
                            </AddUserForm>
                            <InviteRoleHint>
                              {CUSTOM_ROLES_INVITE_HINT_LEAD}{' '}
                              {canManageUsers ? (
                                <InviteRoleHintLink
                                  type='button'
                                  onClick={() =>
                                    setStartCreateCustomRoleToken(
                                      token => token + 1,
                                    )
                                  }
                                >
                                  {CUSTOM_ROLES_INVITE_HINT_ACTION}
                                </InviteRoleHintLink>
                              ) : (
                                CUSTOM_ROLES_INVITE_HINT_ACTION
                              )}
                            </InviteRoleHint>
                          </InviteUserSection>

                          <PeopleOnVenueHeader>
                            <InviteUserTitle>
                              People on this venue
                            </InviteUserTitle>
                            <InviteUserSubtitle>
                              Change someone&apos;s role or remove them from
                              this venue.
                            </InviteUserSubtitle>
                          </PeopleOnVenueHeader>

                          {venue?.additionalUsers &&
                          venue.additionalUsers.length > 0 ? (
                            <UsersList>
                              {venue.additionalUsers.map(user => {
                                const userRole = getUserRole(user)
                                const displayedRoleId = getVenueRoleSelectValue(
                                  userRole,
                                  venue?.customRoles,
                                )
                                const roleColor = getRoleColor(displayedRoleId)
                                const roleDisplayName = getVenueRoleDisplayName(
                                  userRole,
                                  venue?.customRoles,
                                )
                                const roleChipSummary =
                                  getVenueRoleCardChipSummary(
                                    userRole,
                                    venue?.customRoles,
                                  )
                                const missingCustomRoleCopy =
                                  getMissingCustomRoleAssignmentCopy(
                                    userRole,
                                    venue?.customRoles,
                                  )
                                const isPrimaryOwner =
                                  venue?.account &&
                                  venue.account._id === user._id
                                const isSelf =
                                  Boolean(account?._id) &&
                                  String(user._id) === String(account._id)
                                const canEditThisUser =
                                  canManageUsers && !isPrimaryOwner && !isSelf

                                return (
                                  <UserCard key={user._id}>
                                    <UserInfo>
                                      <UserName>
                                        <span>
                                          {user.name || 'Unknown Name'}
                                        </span>
                                        {isSelf ? (
                                          <Tooltip title='Edit your name'>
                                            <EditNameButton
                                              type='button'
                                              data-testid='settings-edit-own-name'
                                              aria-label='Edit your name'
                                              onClick={() =>
                                                openOwnNameEditor(user.name)
                                              }
                                            >
                                              <Icon type='edit' />
                                            </EditNameButton>
                                          </Tooltip>
                                        ) : null}
                                      </UserName>
                                      <UserEmail>{user.emailAddress}</UserEmail>
                                      <UserRole roleColor={roleColor}>
                                        {roleDisplayName}
                                      </UserRole>
                                      {roleChipSummary ? (
                                        <UserRoleChips>
                                          {roleChipSummary}
                                        </UserRoleChips>
                                      ) : null}
                                      {missingCustomRoleCopy ? (
                                        <UserMissingRoleNote>
                                          {missingCustomRoleCopy}
                                        </UserMissingRoleNote>
                                      ) : null}
                                    </UserInfo>
                                    <UserActions>
                                      {canEditThisUser && (
                                        <RoleSelectWrapper
                                          style={{ marginBottom: '8px' }}
                                        >
                                          <VenueRoleSelect
                                            key={`role-select-${user._id}-${userRole}`}
                                            value={userRole}
                                            customRoles={venue?.customRoles}
                                            lockCustomRoles={isFreePlan}
                                            onLockedCustomRole={() =>
                                              setShowFreePlanModal(true)
                                            }
                                            tooltipTitle={
                                              isFreePlan
                                                ? 'Admin, Head Chef / GM, Chef, Order Only, and Kitchen Porter are on OMS Lite. Custom roles are on Starter.'
                                                : 'Change user role'
                                            }
                                            onChange={value =>
                                              handleRoleChange(user._id, value)
                                            }
                                            disabled={
                                              updatingRoleUserId === user._id
                                            }
                                            style={{ width: '100%' }}
                                            size='small'
                                          />
                                        </RoleSelectWrapper>
                                      )}
                                      {canManageUsers && isSelf ? (
                                        <UserMissingRoleNote>
                                          {CANNOT_REMOVE_SELF_COPY}
                                        </UserMissingRoleNote>
                                      ) : null}
                                      {canEditThisUser && (
                                        <Button
                                          type='danger'
                                          size='small'
                                          onClick={() =>
                                            handleRemoveUserClick(user)
                                          }
                                        >
                                          Remove
                                        </Button>
                                      )}
                                    </UserActions>
                                  </UserCard>
                                )
                              })}
                            </UsersList>
                          ) : (
                            <EmptyState>
                              <p>No additional users have been invited yet.</p>
                              <p style={{ fontSize: '12px', color: '#8c8c8c' }}>
                                Invite your team members to collaborate on this
                                venue.
                              </p>
                            </EmptyState>
                          )}
                        </AdditionalUsersSection>

                        <Modal
                          title='Edit your name'
                          visible={editingOwnName}
                          onOk={handleSaveOwnName}
                          onCancel={() => {
                            if (savingOwnName) return
                            setEditingOwnName(false)
                          }}
                          confirmLoading={savingOwnName}
                          okText='Save'
                          data-testid='settings-edit-own-name-modal'
                        >
                          <p style={{ marginTop: 0 }}>
                            This is how your name appears to colleagues on this
                            venue.
                          </p>
                          <Input
                            value={ownNameDraft}
                            onChange={event => {
                              setOwnNameDraft(event.target.value)
                              setOwnNameError('')
                            }}
                            placeholder='Your name'
                            maxLength={80}
                            data-testid='settings-edit-own-name-input'
                          />
                          {ownNameError ? (
                            <p
                              style={{
                                color: '#cf1322',
                                fontSize: 12,
                                margin: '8px 0 0',
                              }}
                            >
                              {ownNameError}
                            </p>
                          ) : null}
                        </Modal>

                        {/* Remove User Confirmation Modal */}
                        <Modal
                          title='Remove User'
                          visible={!!userToRemove}
                          onOk={handleRemoveUserConfirm}
                          onCancel={handleRemoveUserCancel}
                          confirmLoading={isRemovingUser}
                          okText='Remove'
                          okButtonProps={{ danger: true }}
                        >
                          <p>
                            Are you sure you want to remove{' '}
                            <strong>{userToRemove?.emailAddress}</strong> from
                            this venue?
                          </p>
                          <p style={{ color: '#8c8c8c', fontSize: '12px' }}>
                            They will no longer have access to this venue&apos;s
                            orders, recipes, or data.
                          </p>
                        </Modal>

                        {/* Add User Confirmation Modal */}
                        <Modal
                          title='Invite Existing User'
                          visible={showAddUserConfirm}
                          onOk={handleAddUserConfirm}
                          onCancel={handleAddUserCancel}
                          confirmLoading={isAddingUser}
                          okText='Send Invitation'
                          okButtonProps={{ type: 'primary' }}
                        >
                          <p>
                            <strong>{pendingUserEmail}</strong> already has an
                            OMS account. We&apos;ll add their existing account
                            to your venue as{' '}
                            <strong>
                              {getVenueRoleDisplayName(
                                selectedRole,
                                venue?.customRoles,
                              )}
                            </strong>
                            .
                          </p>
                          <div style={{ marginBottom: 16 }}>
                            <label
                              htmlFor='existing-invite-email'
                              style={{
                                display: 'block',
                                marginBottom: 6,
                                fontWeight: 600,
                              }}
                            >
                              Email address
                            </label>
                            <Input
                              id='existing-invite-email'
                              type='email'
                              placeholder='Email address'
                              value={pendingUserEmail}
                              readOnly
                              autoComplete='off'
                            />
                          </div>
                          <div style={{ marginBottom: 16 }}>
                            <label
                              htmlFor='existing-invite-name'
                              style={{
                                display: 'block',
                                marginBottom: 6,
                                fontWeight: 600,
                              }}
                            >
                              Full name
                            </label>
                            <Input
                              id='existing-invite-name'
                              placeholder='e.g. Jane Smith'
                              value={pendingUserName}
                              autoComplete='new-password'
                              name='invitee-full-name'
                              onChange={event => {
                                const next = scrubAutofilledInviterEmail(
                                  event.target.value,
                                  pendingUserEmail,
                                  account?.emailAddress || account?.email || '',
                                )
                                setPendingUserName(next)
                                if (pendingUserNameError) {
                                  setPendingUserNameError('')
                                }
                              }}
                            />
                            <div
                              style={{
                                color: '#8c8c8c',
                                fontSize: 12,
                                marginTop: 6,
                              }}
                            >
                              Optional — leave blank to use{' '}
                              <strong>
                                {pendingUserEmail || 'their email'}
                              </strong>{' '}
                              as the display name (never your own login email).
                            </div>
                            {pendingUserNameError ? (
                              <div
                                style={{
                                  color: '#cf1322',
                                  fontSize: 12,
                                  marginTop: 6,
                                }}
                              >
                                {pendingUserNameError}
                              </div>
                            ) : null}
                          </div>
                          <p>
                            <strong>What happens next:</strong>
                          </p>
                          <ul
                            style={{
                              paddingLeft: '20px',
                              marginBottom: '16px',
                            }}
                          >
                            <li>
                              The next time they log in, they&apos;ll see your
                              venue
                            </li>
                            <li>
                              {getExistingUserInviteAccessCopy(
                                selectedRole,
                                venue?.customRoles,
                              )}
                            </li>
                            <li>
                              We&apos;ll send them a notification email about
                              their new venue access
                            </li>
                          </ul>
                        </Modal>

                        {/* Create New User Modal */}
                        <CreateNewUserModal
                          visible={showCreateNewUserModal}
                          onCancel={handleCreateNewUserCancel}
                          onSubmit={handleCreateNewUser}
                          loading={isCreatingUser}
                          error={createUserError}
                          prefilledEmail={pendingUserEmail}
                          inviterEmail={
                            account?.emailAddress || account?.email || ''
                          }
                          selectedRole={selectedRole}
                          customRoles={venue?.customRoles}
                          isFreePlan={isFreePlan}
                          onFreePlanRole={() => setShowFreePlanModal(true)}
                        />

                        {/* Free Plan Role Modal */}
                        <FreePlanRoleModal
                          visible={showFreePlanModal}
                          onCancel={() => setShowFreePlanModal(false)}
                        />

                        {/* Role Permissions Modal */}
                        <RolePermissionsModal
                          visible={showRolePermissionsModal}
                          onCancel={() => setShowRolePermissionsModal(false)}
                        />

                        {canManagePrimaryOwner && (
                          <ChangePrimaryOwnerModal
                            visible={showChangePrimaryOwnerModal}
                            onClose={() =>
                              setShowChangePrimaryOwnerModal(false)
                            }
                            venue={venue}
                            onPrimaryOwnerChanged={updatedVenue => {
                              // Refresh from backend to ensure additionalUsers and usageLimits are correct
                              if (venueId) {
                                dispatch(getVenue(venueId))
                              } else if (updatedVenue?._id) {
                                dispatch(getVenue(updatedVenue._id))
                              }
                              // Also update local state immediately for snappier UI
                              if (updatedVenue) {
                                dispatch(setVenue(updatedVenue))
                              }
                            }}
                          />
                        )}
                      </Element>
                    </SettingsPane>
                  </SettingsStack>
                )}
              </SettingsTab>
            </Tabs.TabPane>

            {/* GENERAL TAB */}
            <Tabs.TabPane tab={<span>⚙️ General</span>} key='general'>
              <SettingsTab>
                {isBlocked(
                  'settings-general',
                  currentUserRole,
                  venue?.customRoles,
                ) ? (
                  <SettingsPane>
                    <PermissionBlockScreen />
                  </SettingsPane>
                ) : (
                  <SettingsStack>
                    <FoodSafetyHeroBand>
                      <SettingsEyebrow>General</SettingsEyebrow>
                      <FoodSafetyPageTitle>Venue details</FoodSafetyPageTitle>
                      <SettingsLead>
                        Name, contact number, address, logo, and the reminder
                        before order cut-off.
                      </SettingsLead>
                    </FoodSafetyHeroBand>
                    <SuccessHubSettings venueId={venueId} />
                    <OlliePushSettings venueId={venueId} />
                    <SettingsPane>
                      <Element>
                        <H4>Venue name</H4>
                        <Input
                          placeholder='Venue name'
                          value={title}
                          onChange={event => {
                            setTitle(event.target.value)
                          }}
                        />
                      </Element>
                      <Element>
                        <H4>Contact number</H4>
                        <Input
                          type='number'
                          placeholder='Phone Number'
                          value={phoneNumber}
                          onChange={event => setPhoneNumber(event.target.value)}
                        />
                      </Element>
                      <Element>
                        <H4>
                          Sage venue or department code{' '}
                          <Tooltip title='Enter the Sage department or cost centre code where you want purchase invoices from this venue to post when you export from OMS and import into Sage 50.'>
                            <Icon
                              style={{ marginLeft: 4 }}
                              type='question-circle'
                            />
                          </Tooltip>
                        </H4>
                        <Input
                          placeholder='e.g. 100, BAR, KITCHEN'
                          value={sageVenueCode}
                          onChange={event =>
                            setSageVenueCode(event.target.value)
                          }
                        />
                      </Element>
                      <Element>
                        <H4>Venue address</H4>
                        <Input
                          placeholder='Address line 1'
                          value={address.addressLine1}
                          onChange={event => {
                            updateAddress(`addressLine1`, event.target.value)
                          }}
                        />
                        <Input
                          placeholder='Address line 2'
                          value={address.addressLine2}
                          onChange={event => {
                            updateAddress(`addressLine2`, event.target.value)
                          }}
                        />
                        <Input
                          placeholder='Address city'
                          value={address.addressCity}
                          onChange={event => {
                            updateAddress(`addressCity`, event.target.value)
                          }}
                        />
                        <Input
                          placeholder='Address post code'
                          value={address.addressPostCode}
                          onChange={event => {
                            updateAddress(`addressPostCode`, event.target.value)
                          }}
                        />
                      </Element>
                      <Element>
                        <DivFlex>
                          <H4>Your logo </H4>
                          <Popover
                            placement='topLeft'
                            content={content}
                            title={"You can now upload your venue's logo"}
                            overlayStyle={{ maxWidth: '320px' }}
                          >
                            <Icon
                              style={{ marginTop: 2, marginLeft: '8px' }}
                              type='question-circle'
                            />
                          </Popover>
                        </DivFlex>
                        <p>
                          <BodyText>
                            Your logo will appear on reports and emails sent
                            from OMS.
                          </BodyText>
                        </p>

                        {/* File Upload Section */}
                        <LogoUploadSection>
                          <input
                            type='file'
                            accept='image/jpeg,image/jpg,image/png'
                            onChange={handleLogoFileSelect}
                            ref={fileInputRef}
                            style={{ display: 'none' }}
                          />
                          <Button
                            type='default'
                            style={{ borderColor: '#52c41a', color: '#52c41a' }}
                            onClick={() => fileInputRef.current?.click()}
                            loading={isUploadingLogo}
                          >
                            {isUploadingLogo ? 'Uploading...' : 'Choose Logo'}
                          </Button>
                          <span style={{ margin: '0 12px', color: '#8c8c8c' }}>
                            OR
                          </span>
                          <Button
                            type='default'
                            style={{ borderColor: '#52c41a', color: '#52c41a' }}
                            onClick={() => {
                              if (venueLogo && venueLogo.trim()) {
                                // Validate URL format
                                try {
                                  new URL(venueLogo)
                                  setIsUploadingLogo(true)
                                  // Trigger save to update the venue with new logo
                                  submit()
                                  setTimeout(
                                    () => setIsUploadingLogo(false),
                                    1000,
                                  )
                                } catch (error) {
                                  // Show error for invalid URL
                                  alert(
                                    'Please enter a valid URL for your logo',
                                  )
                                }
                              } else {
                                alert('Please enter a logo URL first')
                              }
                            }}
                            loading={isUploadingLogo}
                          >
                            Save URL
                          </Button>
                        </LogoUploadSection>

                        <LogoUrlInput>
                          <Input
                            type='text'
                            placeholder='Enter logo URL (for advanced users)'
                            value={venueLogo}
                            onChange={event => setVenueLogo(event.target.value)}
                          />
                        </LogoUrlInput>

                        <LogoHelpText>
                          <BodyText>
                            Choose a JPG or PNG image under 5MB, or paste an
                            image URL.
                          </BodyText>
                        </LogoHelpText>
                        {venueLogo && (
                          <LogoPreview>
                            <img src={venueLogo} alt='Venue logo preview' />
                            <LogoPreviewActions>
                              <RemoveLogoButton onClick={handleRemoveLogo}>
                                Remove
                              </RemoveLogoButton>
                              {logoUploadSuccess && (
                                <SuccessIndicator>
                                  ✓ Logo uploaded successfully!
                                </SuccessIndicator>
                              )}
                            </LogoPreviewActions>
                          </LogoPreview>
                        )}
                      </Element>
                      <Element>
                        <DivFlex>
                          <H4>Order reminder</H4>
                        </DivFlex>
                        <p>
                          <BodyText>
                            We will send you a handy reminder to send your
                            orders before this time, so you don&apos;t miss your
                            order cut off time.
                          </BodyText>
                        </p>
                        <TimePicker
                          size={'large'}
                          format={'HH:mm'}
                          value={moment(notificationTime)}
                          allowClear={false}
                          onChange={event =>
                            setNotificationTime(event.toDate())
                          }
                        />
                      </Element>
                      <Element>
                        <H4>App access </H4>
                        <p>
                          <BodyText>
                            Venue codes are internal identifiers for your venue
                            (admin tools and support). App access requires email
                            login.
                          </BodyText>
                        </p>
                        <FieldSet>
                          <Legend>Venue code</Legend>
                          <CodeDiv>
                            {isAdmin ||
                            isTFRAdmin ||
                            isJustAdmin ||
                            isGreenAdmin ? (
                              <Input
                                type='text'
                                value={code}
                                onChange={event => setCode(event.target.value)}
                              />
                            ) : (
                              venueCodeFromRedux
                            )}
                          </CodeDiv>
                          <ButtonDiv
                            onClick={() => {
                              refreshVenueCode()
                            }}
                          >
                            <SyncOutlined />
                          </ButtonDiv>
                        </FieldSet>
                      </Element>
                      {isAdmin || venue?.TFRVenue ? (
                        <Element>
                          <H4>Additional app chat support </H4>
                          <Input
                            placeholder='Company support name'
                            value={additionalChatSupport.title}
                            onChange={event => {
                              setAdditionalChatSupport({
                                ...additionalChatSupport,
                                title: event.target.value,
                              })
                            }}
                          />
                          <Input
                            placeholder='Email address'
                            value={additionalChatSupport.emailAddress}
                            onChange={event => {
                              setAdditionalChatSupport({
                                ...additionalChatSupport,
                                emailAddress: event.target.value,
                              })
                            }}
                          />
                        </Element>
                      ) : null}
                      <SaveButton>
                        {showSaved ? (
                          <SavedIndicator>
                            <span>✓ Saved</span>
                          </SavedIndicator>
                        ) : (
                          <Button type='primary' onClick={submit}>
                            <span>Save</span>
                          </Button>
                        )}
                      </SaveButton>
                    </SettingsPane>
                  </SettingsStack>
                )}
              </SettingsTab>
            </Tabs.TabPane>

            {/* EMAIL NOTIFICATIONS & REPORTS TAB */}
            <Tabs.TabPane
              tab={<span>📧 Email Notifications & Reports</span>}
              key='notifications'
            >
              <SettingsTab>
                {isBlocked(
                  'settings-notifications',
                  currentUserRole,
                  venue?.customRoles,
                ) ? (
                  <SettingsPane>
                    <PermissionBlockScreen />
                  </SettingsPane>
                ) : (
                  <SettingsStack>
                    <FoodSafetyHeroBand>
                      <SettingsEyebrow>Email</SettingsEyebrow>
                      <FoodSafetyPageTitle>
                        Email preferences
                      </FoodSafetyPageTitle>
                      <SettingsLead>
                        How often the activity summary goes out, and who
                        receives reports and notifications for this venue.
                      </SettingsLead>
                    </FoodSafetyHeroBand>
                    <SettingsPane>
                      <Element>
                        <H4>Activity summary</H4>
                        <p>
                          <BodyText>
                            How often would you like to receive your OMS
                            Activity Summary?
                          </BodyText>
                        </p>
                        <div>
                          <Radio.Group
                            onChange={e =>
                              setActivityEmailFrequency(e.target.value)
                            }
                            value={activityEmailFrequency}
                          >
                            <Radio value='daily'>Daily</Radio>
                            <Radio value='weekly'>Weekly</Radio>
                            <Radio value='monthly'>Monthly</Radio>
                            <Radio value='off'>Never</Radio>
                          </Radio.Group>
                        </div>
                      </Element>
                      <Element>
                        <DivFlex>
                          <H4>Email Notifications & Reports</H4>
                        </DivFlex>
                        <p>
                          <BodyText>
                            These email addresses will receive statistics,
                            reports, and notifications about your venue.
                          </BodyText>
                        </p>
                        <ReactMultiEmail
                          placeholder='Enter email addresses'
                          emails={statsReciveEmails}
                          style={{ margin: '0px' }}
                          onChange={_emails => {
                            console.log({ _emails })
                            setStatsRecieveEmails(_emails)
                          }}
                          validateEmail={
                            email => isEmail(email) // return boolean
                          }
                          getLabel={(email, index, removeEmail) => (
                            <InnerDiv data-tag key={index}>
                              {email}
                              <span
                                data-tag-handle
                                onClick={() => removeEmail(index)}
                              >
                                ×
                              </span>
                            </InnerDiv>
                          )}
                        />
                      </Element>
                      <SaveButton>
                        {showSaved ? (
                          <SavedIndicator>
                            <span>✓ Saved</span>
                          </SavedIndicator>
                        ) : (
                          <Button type='primary' onClick={submit}>
                            <span>Save</span>
                          </Button>
                        )}
                      </SaveButton>
                    </SettingsPane>
                  </SettingsStack>
                )}
              </SettingsTab>
            </Tabs.TabPane>

            {showSubscriptionsTab && (
              <Tabs.TabPane
                tab={<span>💳 Subscriptions</span>}
                key='subscriptions'
              >
                <TabContent style={{ padding: 0 }}>
                  {activeTab === 'subscriptions' ? <Subscriptions /> : null}
                </TabContent>
              </Tabs.TabPane>
            )}

            {showIntegrationsTab && (
              <Tabs.TabPane
                tab={<span>🔌 Integrations</span>}
                key='integrations'
              >
                <TabContent style={{ padding: 0 }}>
                  {activeTab === 'integrations' ? (
                    <Integrations embedded />
                  ) : null}
                </TabContent>
              </Tabs.TabPane>
            )}

            {/* OMS-admin venue flags — not the customer Xero page */}
            {isAdmin && (
              <Tabs.TabPane tab={<span>🔗 Manage</span>} key='manage'>
                <TabContent>
                  <CardColumn>
                    <Element>
                      <H3>Integrations & Settings</H3>
                      {isAdmin && (
                        <Row>
                          <SwitchSpan>TFR</SwitchSpan>
                          <SwitchComp
                            value={TFRVenue}
                            onChange={checked =>
                              setExclusiveVenueType('TFR', checked)
                            }
                            checked={TFRVenue}
                          />
                        </Row>
                      )}
                      {isAdmin && (
                        <Row>
                          <SwitchSpan>GREEN</SwitchSpan>
                          <SwitchComp
                            value={GREENVenue}
                            onChange={checked =>
                              setExclusiveVenueType('GREEN', checked)
                            }
                            checked={GREENVenue}
                          />
                        </Row>
                      )}
                      {isAdmin && (
                        <Row>
                          <SwitchSpan>JUST</SwitchSpan>
                          <SwitchComp
                            value={JUSTVenue}
                            onChange={checked =>
                              setExclusiveVenueType('JUST', checked)
                            }
                            checked={JUSTVenue}
                          />
                        </Row>
                      )}
                      {isAdmin && (
                        <Row>
                          <SwitchSpan>Dataplus integration</SwitchSpan>
                          <SwitchComp
                            value={dataplusIntegration}
                            onChange={event => {
                              setDataplusIntegration(event)
                            }}
                            checked={dataplusIntegration}
                          />
                        </Row>
                      )}
                      {isAdmin && (
                        <Row>
                          <SwitchSpan>Is prices hidden</SwitchSpan>
                          <SwitchComp
                            value={isPricesHidden}
                            onChange={event => {
                              setIsPricesHidden(event)
                            }}
                            checked={isPricesHidden}
                          />
                        </Row>
                      )}
                      {isAdmin && (
                        <Row>
                          <SwitchSpan>{`Is "Add supplier" button hidden`}</SwitchSpan>
                          <SwitchComp
                            value={isAddSupplierButtonHidden}
                            onChange={event => {
                              setIsAddSupplierButtonHidden(event)
                            }}
                            checked={isAddSupplierButtonHidden}
                          />
                        </Row>
                      )}
                      <Row>
                        <SwitchSpan>Is prices changes visible</SwitchSpan>
                        <SwitchComp
                          value={isPriceChangesVisible}
                          onChange={event => {
                            setIsPriceChangesVisible(event)
                          }}
                          checked={isPriceChangesVisible}
                        />
                      </Row>
                      <Row>
                        <SwitchSpan>Send order reminder</SwitchSpan>
                        <SwitchComp
                          value={orderReminder}
                          onChange={event => {
                            setorderReminder(event)
                          }}
                          checked={orderReminder}
                        />
                      </Row>
                      <Row>
                        <SwitchSpan>{`Is account number editable in app`}</SwitchSpan>
                        <SwitchComp
                          value={isAccountNumberEditable}
                          onChange={event => {
                            setIsAccountNumberEditable(event)
                          }}
                          checked={isAccountNumberEditable}
                        />
                      </Row>
                      {isInvoicesFromRedux && (
                        <Row>
                          <SaveButton>
                            <Button type='primary' onClick={getEmail}>
                              <span>Send OMS Email</span>
                            </Button>
                          </SaveButton>
                        </Row>
                      )}
                    </Element>
                    <SaveButton>
                      {showSaved ? (
                        <SavedIndicator>
                          <span>✓ Saved</span>
                        </SavedIndicator>
                      ) : (
                        <Button type='primary' onClick={submit}>
                          <span>Save</span>
                        </Button>
                      )}
                    </SaveButton>
                  </CardColumn>
                </TabContent>
              </Tabs.TabPane>
            )}
          </StyledTabs>
        </Fragment>
      )}
    </Wrapper>
  )
}

const Wrapper = styled(FadeIn)`
  > div {
    margin-bottom: 15px;

    input {
      margin-bottom: 10px;
    }

    .react-multi-email {
      input {
        margin-bottom: 0px;
      }
    }

    input {
      ::-webkit-outer-spin-button,
      ::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }
    }
  }
`

const Element = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.sm};
  .ant-time-picker-icon {
    top: 35%;
  }
`

const CardColumn = styled(Card)`
  width: 90%;
  max-width: 1000px;
  margin: 0 auto;
  padding: 32px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  display: flex;
  flex-direction: column;
`

const CodeDiv = styled.div`
  margin-left: 10px;
`
const ButtonDiv = styled.a`
  margin: 0 10px 20px 0;
`
const SwitchComp = styled(Switch)``

const SwitchSpan = styled.span`
  font-weight: bold;
  display: inline-block;
  margin-right: 7px;
`
const Row = styled.div`
  margin: 15px 0;
  display: flex;
  justify-content: space-between;
`
// const DayButton = styled(Button)`
//   background-color: ${({ isgreen, theme }) =>
//     isgreen ? theme.colours.avocadoGreen : theme.colours.mayoWhite} !important;
//   border-color: ${({ theme }) => theme.colours.oliveGrey} !important;
//   margin: 5px;
//   font-weight: normal !important;
// `

const DivFlex = styled.div`
  display: flex;
  gap: 1%;
`

// const StyledSection = styled.div`
//   border: 2px solid #bdbbbb;
//   padding: 0 10px;
//   border-radius: 5px;
// `

const FieldSet = styled.fieldset`
  border: 1px solid #e8e8e8;
  border-radius: 5px;
  width: 50%;
  display: flex;
  justify-content: space-between;
  padding: 0 10px;
`

const Legend = styled.legend`
  width: 80px;
  font-size: 0.8em;
  padding: 0 5px;
`

// const AdminFieldSet = styled.fieldset`
//   border: 1px solid #e8e8e8;
//   border-radius: 5px;
//   width: 50%;
//   display: flex;
//   justify-content: space-between;
//   padding: 0 10px;
//   margin-top: 15px;
// `

// const AdminCodeLegend = styled.legend`
//   width: 120px;
//   font-size: 0.8em;
//   padding: 0 5px;
// `

const SaveButton = styled.div`
  float: right;
`

const InnerDiv = styled.div`
  background-color: ${({ theme }) => theme.colours.lettuceGreen} !important;
`

const StyledTabs = styled(Tabs)`
  width: 100%;

  .ant-tabs-nav {
    margin-bottom: 0;
    padding: 0 20px;
    background: transparent;
    border-bottom: 1px solid #e8e8e8;
  }

  .ant-tabs-nav-wrap {
    justify-content: flex-start;
  }

  .ant-tabs-tab {
    font-size: 14px;
    font-weight: 500;
    padding: 12px 20px;
    margin-right: 0;
    border: none;
    border-radius: 6px 6px 0 0;
    background: transparent;
    color: #8c8c8c;
    transition: all 0.2s ease;

    &:hover {
      color: #52c41a;
      background: rgba(82, 196, 26, 0.08);
    }

    &.ant-tabs-tab-active {
      color: #52c41a;
      border-bottom: 2px solid #52c41a;
      background: #fff;
      box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.06);
    }
  }

  .ant-tabs-content-holder {
    background: #fafafa;
    min-height: 500px;
  }

  .ant-tabs-tabpane {
    padding: 0;
  }
`

const TabContent = styled.div`
  width: 100%;
  padding: 32px 20px;
`

const SettingsTab = styled(TabContent)`
  padding: 8px 4px 28px;
`

const SettingsStack = styled.div`
  width: 100%;
  max-width: 52rem;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`

const SettingsPane = styled.div`
  width: 100%;
  padding: 1.1rem 1.15rem 1.15rem;
  background: #fff;
  border: 1px solid ${FOOD_SAFETY_SURFACE.HERO_BORDER};
  border-radius: ${FOOD_SAFETY_SURFACE.CARD_RADIUS};
  box-shadow: ${FOOD_SAFETY_SURFACE.CARD_SHADOW};
  box-sizing: border-box;
  display: flex;
  flex-direction: column;

  ${SaveButton} {
    float: none;
    align-self: flex-end;
    margin-top: 0.35rem;
  }
`

const SettingsEyebrow = styled.p`
  margin: 0 0 0.2rem;
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: ${FOOD_SAFETY_SECONDARY_TEXT};
`

const SettingsLead = styled.p`
  margin: 0.45rem 0 0;
  max-width: 38rem;
  font-size: 0.95rem;
  line-height: 1.45;
  color: ${FOOD_SAFETY_SECONDARY_TEXT};
`

const SettingsNote = styled.p`
  margin: 0.45rem 0 0;
  max-width: 38rem;
  font-size: 0.875rem;
  line-height: 1.4;
  color: ${({ theme }) => theme.colours.bbqBlack || '#262626'};
`

const LogoUploadSection = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
`

const LogoUrlInput = styled.div`
  margin-bottom: 8px;
`

const LogoHelpText = styled.div`
  margin-bottom: 16px;
  color: #8c8c8c;
`

const LogoPreview = styled.div`
  margin-top: 16px;
  padding: 16px;
  border: 2px dashed #d9d9d9;
  border-radius: 8px;
  text-align: center;
  background: #fafafa;

  img {
    max-width: 150px;
    max-height: 150px;
    border-radius: 8px;
    border: 1px solid #e8e8e8;
    margin-bottom: 12px;
  }
`

const LogoPreviewActions = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
`

const RemoveLogoButton = styled.button`
  background: #ff4d4f;
  color: white;
  border: none;
  padding: 4px 12px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;

  &:hover {
    background: #ff7875;
  }
`

const SuccessIndicator = styled.div`
  color: #52c41a;
  font-size: 12px;
  font-weight: 500;
`

const SavedIndicator = styled.div`
  padding: 8px 16px;
  background: #f6ffed;
  border: 1px solid #b7eb8f;
  border-radius: 6px;
  color: #52c41a;
  font-weight: 500;
  font-size: 14px;
`

// User Management Styled Components
const PrimaryOwnerSection = styled.div`
  margin-bottom: 32px;
`

const AdditionalUsersSection = styled.div`
  margin-top: 32px;
`

const InviteUserSection = styled.div`
  margin: 8px 0 24px;
  padding: 16px;
  background: ${FOOD_SAFETY_SURFACE.LIME_WASH};
  border: 1px solid ${FOOD_SAFETY_SURFACE.LIME_EDGE};
  border-radius: ${FOOD_SAFETY_SURFACE.CARD_RADIUS};
`

const InviteUserHeader = styled.div`
  margin-bottom: 12px;
`

const InviteUserTitle = styled.h4`
  margin: 0 0 4px;
  font-size: 16px;
  font-weight: 600;
  color: #262626;
`

const InviteUserSubtitle = styled.p`
  margin: 0;
  font-size: 13px;
  color: #8c8c8c;
  line-height: 1.4;
`

const PeopleOnVenueHeader = styled.div`
  margin: 8px 0 12px;
`

const UserCard = styled.div`
  background: #ffffff;
  border: 1px solid ${FOOD_SAFETY_SURFACE.HERO_BORDER};
  border-radius: ${FOOD_SAFETY_SURFACE.CARD_RADIUS};
  box-shadow: ${FOOD_SAFETY_SURFACE.CARD_SHADOW};
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-top: 12px;
`

const UserInfo = styled.div`
  flex: 1;
`

const UserName = styled.div`
  font-weight: 600;
  font-size: 16px;
  color: #262626;
  margin-bottom: 4px;
  display: flex;
  align-items: center;
  gap: 8px;
`

const EditNameButton = styled.button`
  border: none;
  background: transparent;
  padding: 0;
  margin: 0;
  cursor: pointer;
  color: #8c8c8c;
  display: inline-flex;
  align-items: center;
  line-height: 1;

  &:hover,
  &:focus {
    color: #262626;
  }
`

const UserEmail = styled.div`
  font-size: 14px;
  color: #595959;
  margin-bottom: 4px;
`

const UserRole = styled.div`
  font-size: 12px;
  color: ${props => props.roleColor || '#52c41a'};
  background: ${props => {
    const color = props.roleColor || '#52c41a'
    // Create light background color from role color
    if (color === '#facc15') return '#fef9c3' // Gold background
    if (color === '#22c55e') return '#f6ffed' // Green background
    if (color === '#0ea5e9') return '#e0f2fe' // Blue background
    if (color === '#a855f7') return '#f3e8ff' // Purple background
    if (color === '#fb923c') return '#fff7ed' // Orange background
    if (color === '#0f766e') return '#ccfbf1' // Teal background (custom roles)
    return '#f6ffed'
  }};
  padding: 2px 8px;
  border-radius: 4px;
  display: inline-block;
  margin-bottom: 8px;
  font-weight: 500;
`

const UserRoleChips = styled.div`
  font-size: 12px;
  color: #8c8c8c;
  margin-bottom: 8px;
  line-height: 1.4;
`

const UserMissingRoleNote = styled.div`
  font-size: 12px;
  color: #8c8c8c;
  margin-bottom: 8px;
  line-height: 1.4;
`

const UserAdded = styled.div`
  font-size: 12px;
  color: #8c8c8c;
`

const UserActions = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`

const ContactSupport = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: #8c8c8c;
  background: #fafafa;
  padding: 8px 12px;
  border-radius: 6px;
  border: 1px solid #e8e8e8;
`

const EmptyState = styled.div`
  text-align: center;
  padding: 40px 20px;
  background: #fafafa;
  border: 1px dashed #d9d9d9;
  border-radius: 8px;
  margin-top: 12px;

  p {
    color: #8c8c8c;
    margin-bottom: 16px;
    font-size: 14px;
  }
`

const AddUserForm = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 12px;
  align-items: flex-end;

  .invite-user-email {
    flex: 1 1 200px;
    min-width: 0;
  }

  .invite-role-select {
    flex: 1 1 180px;
    min-width: 0;
  }

  .invite-user-submit {
    flex: 0 0 auto;
    width: 140px;
  }

  @media (max-width: 560px) {
    flex-direction: column;
    align-items: stretch;

    .invite-user-email,
    .invite-role-select,
    .invite-user-submit {
      flex: none;
      width: 100%;
    }
  }
`

const InviteEmailField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`

const InviteFieldLabel = styled.label`
  font-size: 13px;
  font-weight: 600;
  color: #262626;
  line-height: 1.2;
`

const InviteRoleHint = styled.p`
  margin: 0;
  font-size: 13px;
  color: #595959;
  line-height: 1.4;
`

const InviteRoleHintLink = styled.button`
  padding: 0;
  border: none;
  background: none;
  color: #0f766e;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  text-decoration: underline;
`

const CustomRoleCue = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 0;
  border: none;
  background: none;
  color: #0f766e;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;

  &:disabled {
    cursor: default;
    opacity: 0.7;
  }
`

const NewBadge = styled.span`
  display: inline-block;
  padding: 1px 7px;
  border-radius: 999px;
  background: #0f766e;
  color: #ffffff;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
`

const UsersList = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`

const UpgradeBanner = styled.div`
  background: #fff7ed;
  border: 1px solid #fb923c;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
  }
`

const UpgradeBannerText = styled.div`
  flex: 1;
  color: #9a3412;
  font-size: 14px;
  line-height: 1.5;
`

const ViewOnlyMessage = styled.div`
  background: #f0f0f0;
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  padding: 16px;
  margin-top: 16px;
  text-align: center;
  color: #595959;
  font-size: 14px;
  font-style: italic;
`

const RoleSelectWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 180px;
  overflow: visible;
  position: relative;
`

export default Settings
